import React from "react";

const FormCaption = ({ style, title }) => {
  return <div className={`form-field-label ${style}`}>{title}</div>;
};

export default FormCaption;
